import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import AppSection from './components/AppSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <IndexSection />
        <RankingSection />
        <AppSection />
        <FaqSection />
        <MediaSection />
        <FeaturesSection />
        <CardsSection />
        <CarouselSection />
        <UpdatesSection />
        <TopicsSection />
        <ContactSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}